import { useState } from "react";
import { Button } from "../ui/button";
import ReportDownloadButton from "./report-download-button";
import ReportPreviewDialog from "./report-preview-dialog";
import { Text } from "../ui/text";
import { useOutsideClick } from "@/hooks/shared/use-outside-click";
import RightArrowIcon from "../ui/icons/RightArrowIcon";
import { Message } from "../message/message-list";

const GenerateReportButton = ({ message }: { message: Message }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const ref = useOutsideClick(() => {
    // Dialog가 열려있을 때는 외부 클릭을 무시
    if (!isDialogOpen) {
      setIsOpen(false);
    }
  });

  return (
    <div ref={ref}>
      {isOpen ? (
        <div className="flex gap-[10px]">
          <ReportPreviewDialog
            content={message?.message}
            references={message?.referencesContent}
            createdAt={message?.conversationTime}
            onOpenChange={setIsDialogOpen}
          />
          <ReportDownloadButton
            type="pdf"
            content={message?.message}
            references={message?.referencesContent}
            createdAt={message?.conversationTime}
          />
          <ReportDownloadButton
            type="word"
            content={message?.message}
            references={message?.referencesContent}
            createdAt={message?.conversationTime}
          />
        </div>
      ) : (
        <div>
          <Button
            onClick={() => setIsOpen(true)}
            className="border border-primary-80 rounded-[8px] px-4 py-[10px]"
            style={{
              background:
                "linear-gradient(144deg, #ECFCFA 13.78%, #FEF9F7 49.93%, #FFF 86.08%)",
            }}
          >
            <Text variant="body-regular">Generate Report</Text>
            <RightArrowIcon color="#333333" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default GenerateReportButton;
